import { RadioGroup } from '@panwds/react-form-legacy'
import { Body, Bold } from '@panwds/react-ui'
import { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { APP_ID_PRISMA_ACCESS_EDITION } from '../../../common/constants/GlobalConstants'
import { ALLOCATION_OPTION, CHOOSE_LICENSE_LABEL, SUBSCRIPTION_ACTION_EDIT } from '../constants/SubscriptionConstant'
/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on SubscriptionAllocation.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */


const SubscriptionAllocation = ({ changeHandler, defaultAllocation, item, rest }) => {
  const { setValue } = useFormContext()

  const getRadioButtonStatus = useMemo(() => {
    return !!(rest.licenseAction === SUBSCRIPTION_ACTION_EDIT && rest.licenseInfo[APP_ID_PRISMA_ACCESS_EDITION])

  }, [rest.licenseAction, rest.licenseInfo])

  useEffect(() => {
    setValue(item.allocation?.formFieldName, String(defaultAllocation))
  }, [defaultAllocation, item.allocation?.formFieldName, setValue])
  return <div className='tw-flex-1 tw-mr-2 tw-flex-none'>
    <Body addClassName="tw-pb-2 tw-pl-1" size="sm"><Bold appearance='semibold'>{CHOOSE_LICENSE_LABEL}</Bold></Body>
    <div className="tw-space-y-4">
      <RadioGroup name={item.allocation?.formFieldName} items={ALLOCATION_OPTION}
        disabled={getRadioButtonStatus}
        register={{
          required: { getRadioButtonStatus },
          onChange: event => {
            changeHandler(event?.target?.value, item.allocation?.formFieldName)
          }
        }}/>
    </div>
  </div>
}

export default SubscriptionAllocation
